<div *ngIf="confidenceType === 'numeric'">
  <ui-slider [uiMin]="0" [uiMax]="1" [uiStep]="0.1" [ngModel]="confidence" [uiTipFormatter]="sliderTipFormatter" [uiTabindex]="-1" (ngModelChange)="setConfidence($event)"></ui-slider>
</div>

<div class="text" *ngIf="confidenceType === 'text' && mappings">
  <ui-tag
    class="confidence-tag"
    *ngFor="let mapping of mappings"
    [ngClass]="textTypeColorClassMapping[mapping.color]"
    [uiChecked]="mapping.name === currentMapping?.name"
    [attr.data-test-id]="'update-kr-confidence-label-' + mapping.name"
    [attr.aria-label]="ariaLabelsMapForTextLevels[mapping.name]"
    [attr.aria-pressed]="mapping.name === currentMapping?.name"
    (click)="setCurrentMapping(mapping)"
    (keydown.enter)="setCurrentMapping(mapping)"
    (keydown.space)="setCurrentMapping(mapping)"
    uiMode="checkable"
    role="button"
    tabindex="0">
    {{ mapping.name }}
  </ui-tag>
</div>

<div class="emoji" *ngIf="confidenceType === 'emoji' && mappings">
  <div
    *ngFor="let mapping of mappings"
    [class]="'confidence-tag twa twa-xxl twa-' + mapping.name"
    [class.twa-3x]="mapping.name === currentMapping?.name"
    [attr.data-test-id]="'update-kr-confidence-label-' + mapping.name"
    (click)="setCurrentMapping(mapping)"></div>
</div>
